import { render } from "./UsuarioEdit.vue?vue&type=template&id=d0ceb6c2"
import script from "./UsuarioEdit.vue?vue&type=script&lang=js"
export * from "./UsuarioEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__